import ProductCategory from "./ProductCategory";
export default ProductCategory;